var map = {
	"./albert einstein.jpg": 67426,
	"./android.jpg": 13934,
	"./apple logo.jpg": 2478,
	"./chat gpt.jpg": 93546,
	"./fb.jpg": 74447,
	"./ms office.jpg": 91419,
	"./uc browser 1.jpg": 83598,
	"./whats app.jpg": 52615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78257;